import { Typography, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { EmptyView, type EmptyViewProps } from 'settle-ui/components/EmptyView/EmptyView'
import { Button } from 'settle-ui/components/Button/Button'

interface ErrorBoundaryFallbackProps extends Pick<EmptyViewProps, 'error'> {
  children?: React.ReactNode
  subtitle?: string
  title?: string
}

export const ErrorBoundaryFallback: React.FC<ErrorBoundaryFallbackProps> = ({
  title,
  subtitle,
  children,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <EmptyView {...props} sx={{ position: 'relative' }} slotProps={{ typography: { component: Stack, gap: 3 } }}>
      <Typography variant="inherit">{title ?? t('somethingWentWrong')}</Typography>
      {subtitle && <Typography variant="body2">{subtitle}</Typography>}
      <Button onClick={() => location.reload()}>{t('reloadPage')}</Button>
      {children}
    </EmptyView>
  )
}
